import { render, staticRenderFns } from "./logisimportlist.vue?vue&type=template&id=b69f9bd0&scoped=true"
import script from "./logisimportlist.vue?vue&type=script&lang=js"
export * from "./logisimportlist.vue?vue&type=script&lang=js"
import style0 from "./logisimportlist.vue?vue&type=style&index=0&id=b69f9bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69f9bd0",
  null
  
)

export default component.exports